module.exports = __webpack_public_path__ + "static/media/Finnovex-South-Africa-2024.491853bb.png";